module.exports = __webpack_public_path__ + "static/media/logo-silestone-xm.22a9ef38.svg";